import React, { Component } from 'react';
import './home.css';
import Header from './Header';
import OwlCarousel from 'react-owl-carousel2';

class Home extends Component {
  render() {
    const options = {
      items: 1,
      nav: false,
      autoplay: true,
      loop:true,
      smartSpeed:700,
      animateOut: 'fadeOut',
      responsive: {
        '0': { items: 1 }
      }
  };
    return (
      <div id="home">
        <div className="image-topright"></div>
        <div className="container">
          <Header />
          <div className="row">
            <div className="col-md">
              <div className="content">
                  <OwlCarousel ref="car" options={options} >
                    <div className="owl-item-holder">
                      <h1>
                        <i>Explode Productivity</i>
                        <br/>
                        <span>with Seamless Workflow</span>
                      </h1>
                      <div className="img-holder">
                          <img src={require('../../images/home/ExplodeProductivity.png')} className="img-fluid" alt="carousel"/>
                      </div>
                    </div>
                    <div className="owl-item-holder">
                      <h1>
                        <i>Revolutionary Change</i>
                        <br/>
                        <span>with Adaptive Platform</span>
                      </h1>
                      <div className="img-holder">
                          <img src={require('../../images/home/RevolutionaryChange.png')} className="img-fluid" alt="carousel"/>
                      </div>
                    </div>
                    <div className="owl-item-holder">
                      <h1>
                        <i>Lightning Speed</i>
                        <br/>
                        <span>with Paperless Processes​</span>
                      </h1>
                      <div className="img-holder">
                          <img src={require('../../images/home/LightingSpeed.png')} className="img-fluid" alt="carousel"/>
                      </div>
                    </div>
                  </OwlCarousel>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Home;


// WEBPACK FOOTER //
// ./src/components/Home/Home.js